import React, { MouseEventHandler } from 'react';

import { SxProps, Typography } from '@mui/material';
import { TBlock } from '@wp-block-builder/package';
import { useSetCurrentBlockId } from '@wp-block-builder/stores/WaypointDocumentEditorStore/CurrentBlockStore';

const ROOT_SX: SxProps = {
  whiteSpace: 'nowrap',
  '&:hover': { textDecoration: 'underline' },
};

type Props = {
  block: TBlock;
  reverseIndex: number;
};
export default function BlockTab({ reverseIndex, block }: Props) {
  const setCurrentBlockId = useSetCurrentBlockId();
  const onClick: MouseEventHandler<HTMLElement> = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setCurrentBlockId(block.id);
  };

  return (
    <Typography component="span" variant="body2" onClick={onClick} sx={ROOT_SX}>
      <Contents reverseIndex={reverseIndex} block={block} />
    </Typography>
  );
}

function Contents({ block, reverseIndex }: Props) {
  const { type, props } = block;
  switch (type) {
    case 'LoopContainer':
      if (reverseIndex <= 2) {
        return (
          <>
            {'Loop '}
            <em>{props?.loopArgumentName || 'val'}</em>, <em>{props?.loopIndexName || 'index'}</em>
            {' in '}
            <em>{props?.loopTemplate || 'undefined array'}</em>
          </>
        );
      }
      return <>Loop</>;
    case 'Html':
      return <>HTML</>;
    case 'ColumnsSection':
      return <>Columns</>;
    case 'ContainerYield':
      return <>Template content</>;
    case 'Container':
    case 'Heading':
    case 'Button':
    case 'Divider':
    case 'Text':
    case 'Image':
    default:
      return <>{type}</>;
  }
}
